import CardModifier from './CardModifier';
import GameObject from 'GameObject/GameObject';
import Sprite from 'Prototype/Sprite';
import Point from 'Utility/Point';
import Game from 'Game';

export default class IceModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        const iceSprite = GameObject.Instantiate(Sprite, {
            name: 'iceSprite',
            texture: 'ice_1',
            anchor: new Point(0.5, 0.5),
        });

        this.addChild(iceSprite);
    }
    
    public static async preload(): Promise<void> {
        Game.resource.add(
            'ice-card',
            'resource/graphics/sprite_sheets/ice_card_animation.json'
        );
    }  
}
